import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PolicyService} from '../../../policy/services/policy.service';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {Policy} from '../../models/policy.model';
import {PolicyStore} from '../../../policy/state/policy.store';
import {UserStore} from '../../../authentication/state/user.store';
import {RouterLinks, Superflow} from '../../constants';
import {UnderwriterService} from '../../../underwriter/services/underwriter.service';
import {QuotesService} from 'src/app/modules/quotes/services/quotes.service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ClaimGuardService} from '../../services/claim-guard.service';
import {GetPoliciesRequest} from '../../models/get-policies-request.model';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
import {QuestionFlowSessionStore} from '../../questions/state/question-flow-session.store';
import { ClaimsService } from 'src/app/modules/claim/services/claims.service';
import { ShoppingCartStore } from '../../questions/state/shopping-cart-store';
import { ShoppingCartItem } from '../../models/underwriter.model';
import { PushNotifications } from '@capacitor/push-notifications';
import { ClaimStore } from 'src/app/modules/claim/state/state/claims-session.store';
import { FlowPlayerService } from '../../services/flow-player.service';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { Alert } from '../../utilities';
import { EmergencyServicesModalComponent } from '../../../claim/emergency-services-modal/emergency-services-modal.component';

declare var $: any;
declare var accounting: any;
declare function notify(): any;
declare function initTableSearch($input: any): any;
declare function initTableSort($control: any): any;
declare function genMobileTableLabels($input: any): any;
declare function initCustomDropdowns(): any;
declare function initFilters($elements: any): any;
//declare function initGlobalSearch(): any;
declare function initSearchRangeDatePicker(): any;

@Component({
    selector: 'app-global-search',
    templateUrl: './global-search.component.html',
    styleUrls: ['./global-search.component.scss'],
    standalone: false
})
export class GlobalSearchComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  @ViewChild('viewElement') viewElement: any;
  @ViewChild('emergencyServicesModalComponent', {static: false}) emergencyServicesModalComponent: EmergencyServicesModalComponent;
  dtOptions: any = {};
  request = new GetPoliciesRequest();
  person: any;
  policies: Policy[] = [];
  tablePolicies: Policy[] = [];
  accounting: any;
  categories: any[] = [];
  notify: any;
  showTableContent = false;
  statusFilterAll = 'All';
  productFilterAll = 'All';
  question: any;
  brokers: any[] = [];
  insurers: any[] = [];
  users: any[] = [];
  broker_id = 0;
  RouterLinks = RouterLinks;
  selectedInsurer: any;
  mode = 'Policies';
  search_query = '';
  //searchChanged = new Subject<string>();
  brokerage_ids = [];
  broker_ids = [];
  statuses = [];
  status_ids = [1];
  product_ids = [];
  underwriting = false;
  claims = false;
  uwDataset: any;
  uwView = 'Policies';
  sort: string = 'name';
  order: string = 'asc';
  dataset: any;
  policyCount = 0;
  quoteCount = 0;
  claimCount = 0;
  underwriterCount = 0;
  viewChange = false;
  isEmpty = false;
  documentPageRoute: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private policyService: PolicyService,
    private claimStore: ClaimStore,
    private flowPlayer: FlowPlayerService,
    private userStore: UserStore,
    public quotesService: QuotesService,
    private store: PolicyStore,
    private underwriterService: UnderwriterService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    public policyQuery: PolicyQuery,
    private claimService: ClaimsService,
    private policyStore: PolicyStore,
    private shoppingCartStore: ShoppingCartStore,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    public globalQuestionService: GlobalQuestionService,
    private ref: ChangeDetectorRef,
    private claimGuardService: ClaimGuardService,
  ) {
    const isPolicyRejected = this.router.getCurrentNavigation()?.extras?.state?.policyRejected;
    this.notify = notify();
    if (isPolicyRejected) {
      this.underwriterService.notifyToast(`Policy ${isPolicyRejected} successfully rejected`, 'info');
    }
    this.globalQuestionService.spinner(true);
    this.mode = localStorage.getItem('mode');
    this.route.queryParams.subscribe(params => {
      this.request.search_query = params?.q;
    })
    this.documentPageRoute = localStorage.getItem('previous-document-page');
  }

  ngOnInit(): void {
   
    this.person = this.userStore.getValue();
   
    this.globalQuestionService.setPushToken();
    if (!this.mode) {
      this.mode = 'Policies';
    }
    if (this.person) {
      if (this.person.console_access){
        this.underwriting = true;
        this.claims = true;
      }
      if (this.person.underwriter){
        this.underwriting = true;
        this.mode = "Underwriting";
        
      }
     
    }

    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    this.setDtOptions();
  }

  ngAfterViewInit(): void {
   //this.globalQuestionService.spinner(false);
   setTimeout(() => {
      this.initGlobalSearch();
     initSearchRangeDatePicker();
     this.dtTrigger.next(undefined);
     $('#global-search-input').on('keypress', (e) => {
      if (e.which == 13) {
        this.viewChange = false;
        this.isEmpty = false;
        this.search_query = e.target.value;
        this.searchChange();
      }
    });
   }, 2000);
   
  }
  initGlobalSearch(): void {
    var $globalSearch = $("#global-search");
    var $globalSearchInput = $("#global-search-input");
    var $globalSearchClear = $("#global-search-clear");
    var $globalSearchAdvancedTrigger = $("#global-search-advanced");
    var $globalSearchAdvancedModal = $("#advanced-search-modal");

    // Autocomplete init
    var options = {
      url: function (phrase) {
        return "/assets/global-search-data.json?phrase=" + phrase;
      },
      listLocation: "items",
      getValue: "name",

      // matchResponseProperty: "inputPhrase", 
      // enable matchResponseProperty attribute ...the response should include the inputPhrase value (see example in json) to match the incoming request
      // this will ensure we get back the correct request (see: http://easyautocomplete.com/guide#sec-async)         
      requestDelay: 350,  // only perform requests 350ms after each input
      minCharNumber: 2, // will only begin requests if 2 or more characters in input           

      template: {
        type: "custom",
        method: function (value, item) {
          return "<svg class='icon'><use xlink:href='#" + item.iconId + "'></use></svg><span>" + value + "</span><small>" + item.type + "</small>";
        }
      },

      // custom settings to show input value as a 'search all' result
      includePartial: true,
      partialValue: "name",
      partialTemplate: [
        { type: "‒ search all results" },
        { iconId: "search-all" }
      ],
      // end custom settings

      adjustWidth: false,
      list: {
        match: {
          enabled: true // show only matched items
        },
        sort: {
          enabled: false
        },
        maxNumberOfElements: 0,
        onLoadEvent: function () {

        },
        onShowListEvent: function () {
          $globalSearch.addClass('has-result');
          $('body').addClass('modal-open');
        },
        onHideListEvent: function () {
          $globalSearch.removeClass('has-result');
          $('body').removeClass('modal-open');
        },
        onChooseEvent: function () {
          var value = $globalSearchInput.getSelectedItemData().name;

          // demo update title            
          $('#search-result-title').html(`Search results for <strong>'${value}'</strong>`);

        },
      }
    };

    $globalSearchInput.easyAutocomplete(options);


    $globalSearchInput
      .on('focus', function () {
        // $globalSearch.addClass('is-expanded');
      })
      .on('blur', function () {
        if ($(this).val().length == 0) {
          // $globalSearch.removeClass('is-expanded');         
        }
      })
      .on('change', function () {
        if ($(this).val().length == 0) {
          // $globalSearch.removeClass('is-expanded');  
          $globalSearchClear.removeClass('is-active');
        }
      })
      .on('input', function () {
        // show/hide clear button
        if ($(this).val().length > 0) {
          $globalSearchClear.addClass('is-active');
        } else {
          $globalSearchClear.removeClass('is-active');
        }
      });


    // demo mobile back click
    $('#global-search-back').on('click', function (e) {
      e.preventDefault();
      location.href = 'everything.b2b-dashboard-tables.html'
    });


    // demo carry global search input value into advanced search modal
    $globalSearchAdvancedModal.on('shown.bs.modal', function (e) {
      $('#advanced-search-keyword')
        .trigger('focus')
        .val($globalSearchInput.val());

      // ensure modal is scrolled to top
      $('body').addClass('modal-open');
    });

    function resetAdvancedSearchForm(){
      $('#advanced-search-form').trigger('reset');
      $('#advanced-search-submit').attr('disabled', true);
      $('#advanced-search-clear').attr('disabled', true);
    }  
    
    // demo clear advanced search form resest on global search clear
    $globalSearchClear.on('click', () =>{
      resetAdvancedSearchForm();
      //this.search_query = '';
      //this.searchChange();
    });

    // demo clear advanced search form on reset click
    $('#advanced-search-clear').on('click', function (e) {
      e.preventDefault();
      resetAdvancedSearchForm();      
    });
  }
  searchChange(): void {
      this.request.search_query = this.search_query;
      this.request.page = 1;
      this.request.start = 0;
      this.rerender();
  }
  clearSearch(): void{
    this.search_query = '';
    this.searchChange();
  }
  initCustomSelect(): void {
    $(`#selectBroker`).selectmenu({
      change: (_event, data) => {
        this.userStore.update({brokerage_id: data.item.value});
      }
    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(undefined);
      //window.location.reload();
    });
    
  }
  postSignup(policy: any){
    console.log(policy);
    this.policyStore.setActive(policy?.policy_id);
    const policies = [policy];
    this.policyStore.set(policies);
    this.questionFlowSessionStore.update({
      css: policy?.category_name?.substring(0, policy?.category_name?.indexOf('.'))?.toLowerCase(),
    });
    localStorage.setItem('previous-document-page', this.router.url);
    this.router.navigate(['/policy-post-signup-details-required']);
  }
  goTo(policy: any, event: any): void {
    if (event?.target?.nodeName === 'use' ||
      event?.target?.nodeName === 'svg.icon' ||
      event?.target?.nodeName === 'svg' ||
      event?.target?.cellIndex === 6) {
      return;
    }
    if (policy.policy_status !== 'Active' && this.mode === "Quotes"){
      //Alert('')
      $('#error-modal').modal('show');
      $('.error-text').html(`This quote cannot be edited due to it’s current state (${policy.policy_status}).`);
      return;
    }
    
    localStorage.setItem('previous-document-page', this.router.url);
    //policy.benefits = JSON.parse(policy?.benefits);
    // policy.categories = JSON.parse(policy?.categories);
    // policy.parsedClasses = JSON.parse(policy?.classes);
    // policy.collation = JSON.parse(policy?.collation);
    // //policy.documents = JSON.parse(policy?.documents);
    // policy.included = JSON.parse(policy?.included);
    //policy.person = JSON.parse(p?.person);
    //policy.parsedRatings = JSON.parse(policy?.ratings);
    const policies = [policy];
    this.policyStore.set(policies);
    this.store.setActive(policy.policy_id); // nice
    switch (this.mode) {
      case 'Underwriting':
        this.router.navigate([`/${RouterLinks.UnderwriterLanding}`]);
        break;
      case 'Claims':

        this.claimService.editClaim(+policy.policy_id, policy.session_id)
          .subscribe((response: any) => {
            if (!response) {
              return;
            }
            var new_session_id = response[0].new_session_id;
            this.questionFlowSessionStore.update({
              session_id: new_session_id,
              category_id: policy?.category_id,
              css: policy?.css,
              flow_id: 14,
              superflow_id: Superflow.personal_claim
            });

            this.shoppingCartStore.reset();

            this.globalQuestionService.getShoppingCart(0, 'question-flow', 0, policy?.product_id ? policy?.product_id : 0)
              .subscribe((shoppingCartItems: ShoppingCartItem[]) => {

                if (!shoppingCartItems?.length) {
                  return;
                }
                let activeCartItem = 0;
                this.shoppingCartStore.set(shoppingCartItems);
                if (activeCartItem > 0) {
                  this.shoppingCartStore.setActive(activeCartItem);
                }
              })
            this.router.navigate([`/${RouterLinks.ClaimEdit}`]);
          })
        break;
      case 'Quotes':
        const parameters = new Map<string, string>();
        parameters.set('session_id', policy.session_id.toString());
        this.globalQuestionService.runCommandNew(`resumeFlow`, parameters)
          .subscribe(flow => {
            this.questionFlowSessionStore.update({
              session_id: policy.session_id
            });
            console.log(flow)
            this.router.navigateByUrl(`/${flow[0]?.url}`);
          });
        break;
      case 'Policies':
        this.router.navigate([`/${RouterLinks.PolicyOverview}`]);
        break;
    }
    // if (this.person.underwriter && this.person.broker_id !== 0) {
    //   $('#view-modal').modal('show');
    //   return;
    // }
    // if (this.person.underwriter) {
    //   this.router.navigate([`/${RouterLinks.UnderwriterLanding}`]);
    // } else {
    //   if (this.mode === 'Quotes'){
    //     const parameters = new Map<string, string>();
    //     parameters.set('session_id', policy.session_id.toString());
    //     this.globalQuestionService.runCommandNew(`resumeFlow`, parameters)
    //       .subscribe(flow => {
    //         this.questionFlowSessionStore.update({
    //           session_id: policy.session_id
    //         });
    //         console.log(flow)
    //         this.router.navigateByUrl(`/${flow[0]?.url}`);
    //       });
    //   }
    //   else{
    //     this.router.navigate([`/${RouterLinks.PolicyOverview}`]);
    //   }

    // }
  }

  applyFilters(): void {
    this.rerender();
  }

  setFilterProduct(product: string): void {
    let selectedOptions = [];
    const checkboxes = document.getElementsByName(product);

    for (const c of checkboxes) {
      const el = c as HTMLInputElement;

      if (el.checked) {
        if (el.value === 'all') {
          selectedOptions = [];
          selectedOptions.push(el.value);
        } else {
          selectedOptions = selectedOptions.splice(selectedOptions.indexOf('all'), 1);
          selectedOptions.push(el.value);
        }

      } else {
        selectedOptions = selectedOptions.splice(selectedOptions.indexOf(el.value), 1);
      }
    }

  }

  setFilterStatus(event: string): void {
    this.statusFilterAll = event;
  }

  setDtOptions(): void {
    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      destroy: true,
      serverSide: true,
      //processing: true,
      displayStart: 0,
      //order: [[ 0, 'asc']] ,
      data: null,
      language: {
        info: '<em>_START_-_END_</em> / _TOTAL_',
        lengthMenu: 'Rows per page: _MENU_',
        infoEmpty: 'No entries found',
        processing: 'Processing... please wait'
      },
      dom: 'fr<"table-responsive"t><"table-pagination"<"table-pagination__controls"<"table-pagination__control"l>><"table-pagination__nav"ip>>',
      drawCallback: function (settings) {
        //disable pagination if only 1 page of results
        var pagination = $('.table-pagination');
        if (this.api().page.info().pages > 1) {
          $('#table-wrap').removeClass('no-pagination');
        } else {
          $('#table-wrap').addClass('no-pagination');
        }
        setTimeout(() => {
          // TODO: make padTable function and don't use lame timeout
          var $brokerTable = $('#broker-table');
          $brokerTable.css({ 'padding-bottom': 0 })
          var numResults = $brokerTable.find('tbody tr').length;
          if (numResults < 11) { 
              var tdHeightInPixels = 53;
              var paddingInPixels = (11 - numResults) * tdHeightInPixels;
              $brokerTable.css({ 'padding-bottom': paddingInPixels + 'px' });
          } 
        }, 1000);
      },
      ajax: (dataTableParams: any, callback) => {
        this.request.sort_order = dataTableParams.order[0].dir;
        this.isEmpty = false;
        if (dataTableParams?.length) {
          this.request.page_size = dataTableParams?.length;
        }
        if (dataTableParams?.start && dataTableParams?.length) {
          this.request.page = Math.floor((dataTableParams?.start + dataTableParams?.length) / dataTableParams?.length);
        }
        if (dataTableParams?.start === 0) this.request.page = 1;
        this.request.person_id = this.person?.person_id;
        this.request.broker_id = this.selectedInsurer?.insurer_id ? this.selectedInsurer?.insurer_id : 0;
        this.request.product_type_id = 1;

        if (this.brokerage_ids?.length) {
          this.request.brokerage_id = this.brokerage_ids.join(',');
        }

        if (this.broker_ids?.length) {
          this.request.broker = this.broker_ids.join(',');
        }
        else{
          this.request.broker = "";
        }

        if (this.status_ids?.length) {
          this.request.status = this.status_ids.join(',');
        }

        if (this.product_ids?.length) {
          this.request.product = this.product_ids.join(',');
        }
        
        if (!this.viewChange) {
          this.globalQuestionService.spinner(true);
          let parameters = new Map<string, string>();
          parameters.set('broker_id', this.request?.broker_id?.toString());
          parameters.set('page', this.request?.page?.toString());
          parameters.set('page_size', this.request?.page_size?.toString());
          parameters.set('person_id', this.request?.person_id?.toString());
          parameters.set('product', this.request?.product?.toString());
          parameters.set('search_query', this.request?.search_query?.toString());
          parameters.set('broker', this.request?.broker?.toString());
          parameters.set('status', this.request?.status?.toString());
          parameters.set('brokerage_id', this.request?.brokerage_id?.toString());
          this.globalQuestionService.runCommandNew(`getGlobalSearch`, parameters, true)
            .subscribe((res: any[]) => {

              this.dataset = res;
              if (!this.dataset[0][0].data && !this.dataset[1][0].data && !this.dataset[2][0].data && !this.dataset[3][0].data) {
                this.isEmpty = true;
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  displayStart: dataTableParams?.start
                });
                this.policyCount = 0;
                this.quoteCount = 0;
                this.claimCount = 0;
                this.underwriterCount = 0;
                this.globalQuestionService.spinner(false);
                return;
              }
              this.policyCount = this.dataset[0][0]?.recordsfiltered;
              this.quoteCount = this.dataset[1][0]?.recordsfiltered;
              this.claimCount = this.dataset[2][0]?.recordsfiltered;
              this.underwriterCount = this.dataset[3][0]?.recordsfiltered;
              if (res?.length) {
                this.policies = [];
                this.globalQuestionService.spinner(false);
                setTimeout(() => {
                  initTableSearch($('#policy-table'));
                }, 1000);
                let items = JSON.parse(res[0][0]?.data);
                if (this.mode === 'Policies') {
                  items = JSON.parse(res[0][0]?.data);
                  callback({
                    recordsTotal: res[0][0]?.recordstotal ?? 10,
                    recordsFiltered: res[0][0]?.recordsfiltered ?? 10,
                    displayStart: dataTableParams?.start,
                  });
                }
                if (this.mode === 'Quotes') {
                  items = JSON.parse(res[1][0]?.data);
                  callback({
                    recordsTotal: res[1][0]?.recordstotal ?? 10,
                    recordsFiltered: res[1][0]?.recordsfiltered ?? 10,
                    displayStart: dataTableParams?.start,
                  });
                }
                if (this.mode === 'Claims') {
                  items = JSON.parse(res[2][0]?.data);
                  callback({
                    recordsTotal: res[2][0]?.recordstotal ?? 10,
                    recordsFiltered: res[2][0]?.recordsfiltered ?? 10,
                    //displayStart: dataTableParams?.start,
                    //data: items
                  });
                }
                if (this.mode === 'Underwriting') {
                  items = JSON.parse(res[3][0]?.data);
                  callback({
                    recordsTotal: res[3][0]?.recordstotal ?? 10,
                    recordsFiltered: res[3][0]?.recordsfiltered ?? 10,
                    //displayStart: dataTableParams?.start,
                    //data: items
                  });
                }
                if (items?.length) {
                  for (const item of items) {
                    this.policies.push(item);
                  }
                }
                setTimeout(() => {
                  if (this.policies.length === 0) {
                    this.isEmpty = true;
                  }
                 }, 500);
                genMobileTableLabels('#broker-table');
                initFilters(
                  {
                    filterWrap: $('#filter-dropdown'),
                    filterList: $('#status-filter-list, #products-filter-list'),
                    filterBtn: $('#filter-apply'),
                    mobileFilterWrap: $('#modal-traymenu-filters'),
                    mobileFilterList: $('#mobile-status-filter-list, #mobile-products-filter-list'),
                    mobileFilterBtn: $('#mobile-filter-apply')
                  }
                );
                this.globalQuestionService.spinner(false);
              } else {
                this.globalQuestionService.spinner(false);
              }
            }, error => {
              this.globalQuestionService.spinner(false);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                displayStart: 0
              });
              $('#error-modal').modal('show');
              $('.error-text').html(error?.error?.Message);
            });
        }
        else{
           this.policies = [];
          if (this.mode === 'Policies') {
            
            const items = JSON.parse(this.dataset[0][0]?.data);
            if (items?.length) {
              for (const item of items) {
                this.policies.push(item);
              }
            }
            callback({
              recordsTotal: this.dataset[0][0]?.recordstotal ?? 10,
              recordsFiltered: this.dataset[0][0]?.recordsfiltered ?? 10,
              displayStart: dataTableParams?.start,
            });
          }
          if (this.mode === 'Quotes') {
           
            const items = JSON.parse(this.dataset[1][0]?.data);
            if (items?.length) {
              for (const item of items) {
                this.policies.push(item);
              }
            }
            callback({
              recordsTotal: this.dataset[1][0]?.recordstotal ?? 10,
              recordsFiltered: this.dataset[1][0]?.recordsfiltered ?? 10,
              displayStart: dataTableParams?.start,
            });
            
           }
           if (this.mode === 'Claims') {
            
            const items = JSON.parse(this.dataset[2][0]?.data);
            if (items?.length) {
              for (const item of items) {
                this.policies.push(item);
              }
            }
            callback({
              recordsTotal: this.dataset[2][0]?.recordstotal ?? 10,
              recordsFiltered: this.dataset[2][0]?.recordsfiltered ?? 10,
              displayStart: dataTableParams?.start,
            });
            
           }
           if (this.mode === 'Underwriting') {
            const items = JSON.parse(this.dataset[3][0]?.data);
            if (items?.length) {
              for (const item of items) {
                this.policies.push(item);
              }
            }
            callback({
              recordsTotal: this.dataset[3][0]?.recordstotal ?? 10,
              recordsFiltered: this.dataset[3][0]?.recordsfiltered ?? 10,
              displayStart: dataTableParams?.start,
            });
            
           }
           this.globalQuestionService.spinner(false);
           setTimeout(() => {
            if (this.policies.length === 0) {
              this.isEmpty = true;
            }
           }, 500);
           
           
        }
      },
      
    };
  }
  
  onBrokerageFilterChange(value: any): void {
    if (value === 'all') {
      if ($('#brokerage-all-checkbox').is(':checked')) {
        this.brokerage_ids = [];
        this.insurers.forEach(i => {
          this.brokerage_ids.push(i.insurer_id);
        })
      }
      else {
        $('.brokerage-checkbox').each(function () {
          $(this).prop('checked', false);
        })
      }
      return;
    }
    if (this.brokerage_ids?.length === this.insurers?.length) {
      this.brokerage_ids = [];
    }
    if (this.brokerage_ids?.includes(value)) {
      const index = this.brokerage_ids.findIndex(x => x === value);

      if (index > -1) {
        this.brokerage_ids.splice(index, 1);
      }
    } else {
      this.brokerage_ids.push(value);
    }
  }

  onBrokerFilterChange(value: any): void {
    if (value === 'all') {
      if (this.person.console_access){
        this.broker_ids = []; 
      }
      else{
        if ($('#broker-all-checkbox').is(':checked')){
          this.broker_ids = [];
          this.brokers.forEach(b => {
            this.broker_ids.push(b.person_id);
          })
         
        }
        else{
          this.broker_ids = []; 
          $('.broker-checkbox').each(function(){
            $(this).prop('checked',false);
          })
        }
      }
      return;
    }
    if (this.broker_ids?.length === this.brokers?.length) {
      this.broker_ids = [];
    }
    if (this.broker_ids?.includes(value)) {
      const index = this.broker_ids.findIndex(x => x === value);
      if (index > -1) {
        this.broker_ids.splice(index, 1);
      }
    } else {
      this.broker_ids.push(value);
    }
  }

  onStatusFilterChange(value: any): void {

    if (value === 'all') {
      this.status_ids = [];
      this.statuses.forEach(s => {
        if (this.mode === "Policies"){
          this.status_ids.push(s.policy_status_id);
        }
        else{
          this.status_ids.push(s.quote_status_id);
        }
        
      })
      return;
    }

    if (this.status_ids?.length === this.statuses?.length) {
      this.status_ids = [];
    }
    if (this.status_ids?.includes(value)) {
      const index = this.status_ids.findIndex(x => x === value);

      if (index > -1) {
        this.status_ids.splice(index, 1);
      }
    } else {
      this.status_ids.push(value);
    }
  }

  onProductFilterChange(value: any): void {
    if (value === 'all') {
      this.product_ids = [];
      for (const p of this.categories) {
        this.product_ids.push(p?.product_category_id);
      }
      return;
    }
    if (this.product_ids?.length === this.categories?.length) {
      this.product_ids = [];
    }
    if (this.product_ids?.includes(value)) {
      const index = this.product_ids.findIndex(x => x === value);

      if (index > -1) {
        this.product_ids.splice(index, 1);
      }
    } else {
      this.product_ids.push(value);
    }
  }

  checkIfAllProductsChecked(): boolean {
    return this.categories?.every(p => this.product_ids.includes(p?.product_category_id));
  }
  checkifAllBrokers(): boolean {
    return this.brokers.every(b => this.broker_ids.includes(b?.person_id));
  }
  checkifAllBrokerages(): boolean {
    return this.insurers.every(b => this.brokerage_ids.includes(b?.insurer_id));
  }

  changeMode(mode: string): void {
    localStorage.setItem('mode', mode);
    this.viewChange = true;
    this.mode = mode;
    
    this.dtElement.dtInstance.then((dtInstance: any) => {

    });
    
    this.rerender();
  }
  setView(view): void{
    this.uwView = view;
    let parameters = new Map<string, string>();
    localStorage.setItem("uwView",this.uwView);
    if (this.uwView === "Policies"){
      this.globalQuestionService.runCommandNew(`getPolicyStatuses`, parameters)
      .subscribe(statuses => {
        this.statuses = statuses;
        this.rerender();
      });
    }
    else{
      this.globalQuestionService.runCommandNew(`getQuoteStatuses`, parameters)
      .subscribe(statuses => {
        this.statuses = statuses;
        this.rerender();
      });
    }
    //this.rerender();
  }
  resendQuoteLink(policy: any): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', policy.session_id.toString());
    this.globalQuestionService.runCommandNew(`resumeFlow`, parameters)
      .subscribe(flow => {
        const newParameters = new Map<string, string>();
        newParameters.set('event_id', '2');
        newParameters.set('session_id', policy?.session_id.toString());
        newParameters.set('key', flow[0]?.full_url);
        newParameters.set('email', policy?.person[0]?.email);
        this.globalQuestionService.runCommandNew(`triggerEvent`, newParameters).subscribe(_result => {
          this.notify.init({
            message: '<strong>Quote email sent. &#128522;</strong>', // required
            icon: 'complete',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'success',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
        });
      });
  }
   
  setSort(sort: string): void {
    this.sort = sort
  }
  setOrder(col: string): void {
    this.request.sort_field = col;
  }
  unsort(): void {
    this.policies?.sort((a: any, b: any) => {
      if (a.rownum < b.rownum) {
        return -1;
      }
      if (a.rownum > b.rownum) {
        return 1;
      }
      return 0
    })
  }
  sortTable(): void{
    this.policies?.sort( (a: any, b: any) => {
      switch (this.sort) {
        case 'name':
          if (this.order === 'asc') { if (a.person[0]?.first_name < b.person[0]?.first_name) { return -1; } if (a.person[0]?.first_name > b.person[0]?.first_name) { return 1; } return 0; }
          else { if (a.person[0]?.first_name < b.person[0]?.first_name) { return 1; } if (a.person[0]?.first_name > b.person[0]?.first_name) { return -1; } return 0; }
          break;
        case 'id':
          if (this.order === 'asc') { if (a.policy_id < b.policy_id) { return -1; } if (a.policy_id > b.policy_id) { return 1; } return 0; }
          else { if (a.policy_id < b.policy_id) { return 1; } if (a.policy_id > b.policy_id) { return -1; } return 0; }
          break;
        case 'broker':
          if (this.order === 'asc') { if (a.broker_user < b.broker_user) { return -1; } if (a.broker_user > b.broker_user) { return 1; } return 0; }
          else { if (a.broker_user < b.broker_user) { return 1; } if (a.broker_user > b.broker_user) { return -1; } return 0; }
          break;
        case 'product':
          if (this.order === 'asc') { if (a.category_name < b.category_name) { return -1; } if (a.category_name > b.category_name) { return 1; } return 0; }
          else { if (a.category_name < b.category_name) { return 1; } if (a.category_name > b.category_name) { return -1; } return 0; }
          break;
        case 'status':
          if (this.order === 'asc') { if (a.policy_status < b.policy_status) { return -1; } if (a.policy_status > b.policy_status) { return 1; } return 0; }
          else { if (a.policy_status < b.policy_status) { return 1; } if (a.policy_status > b.policy_status) { return -1; } return 0; }
          break;
        case 'uw':
          if (this.order === 'asc') { if (a.uw_status < b.uw_status) { return -1; } if (a.uw_status > b.uw_status) { return 1; } return 0; }
          else { if (a.uw_status < b.uw_status) { return 1; } if (a.uw_status > b.uw_status) { return -1; } return 0; }
          break;
        case 'date':
          if (this.order === 'asc') { if (a.date_inception < b.date_inception) { return -1; } if (a.date_inception > b.date_inception) { return 1; } return 0; }
          else { if (a.date_inception < b.date_inception) { return 1; } if (a.date_inception > b.date_inception) { return -1; } return 0; }
          break;
        case 'premium':
          if (this.order === 'asc') { if (a.prem_value < b.prem_value) { return -1; } if (a.prem_value > b.prem_value) { return 1; } return 0; }
          else { if (a.prem_value < b.prem_value) { return 1; } if (a.prem_value > b.prem_value) { return -1; } return 0; }
          break;
        default: return 0;
      }
    });
  }
  startClaim(policy: any): void {
    this.policyStore.set([policy]);
    this.policyStore.setActive(policy.policy_id);
    // guard against the policy holder, never the logged-in user (this.person here
    // is the logged-in user, unlike on the policy-* detail pages).
    this.claimGuardService.startClaimFlow(policy?.policy_id, 0, 0, 0, policy?.person?.[0]?.person_id, false)
      .subscribe(result => {
        if (result) {
          this.emergencyServicesModalComponent.showModal(result);
        }
      });
  }
  removeClaim(claim_id: number){
    if(!claim_id) return;
    const parameters = new Map<string, string>();
    parameters.set('claim_id', claim_id.toString());
    this.globalQuestionService.spinner(true);
    this.globalQuestionService.runCommandNew('removeClaim', parameters)
      .subscribe((response: any) => {
        this.rerender();
      });
  }
  downloadQuoteSchedule(item: any): void{
    console.log(item);
    window.open(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${item?.policy_id}&print=false&pdf=true`);
    //this.router.navigateByUrl(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${item?.policy_id}&print=false&pdf=true`);
  }
  viewTranscript(item: any): void{
    console.log(item);
    window.open(`${RouterLinks.PolicyTranscript}?session_id=${item?.session_id}&print=false&pdf=true`);
    //this.router.navigateByUrl(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${item?.policy_id}&print=false&pdf=true`);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
